import { BaseService } from '@/services/base.service'

export class PromotionService {
  static async GetBudgetMerchant (params) {
    try {
      const response = await BaseService.request().post('v1/promotion/budget', params)
      return response.data
    } catch (error) {
      return error.response.data
    }
  }
  
  static async GetPromoMerchant (params) {
    try {
      const response = await BaseService.request().post('v1/promotion/getPromo', params)
      return response.data
    } catch (error) {
      return error.response.data
    }
  }

  static async getMerchantPromo (params) {
    try {
      const response = await BaseService.request().post('v1/promotion/getMc', params)
      return response.data
    } catch (error) {
      return error.response.data
    }
  }

  static async getPromoCheck (params) {
    try {
      const response = await BaseService.request().post('v1/promotion/checkPromo', params)
      return response.data
    } catch (error) {
      return error.response.data
    }
  }
}
